'use client'

import CityFormField from '@tebuto/forms/CityFormField'
import StreetFormField from '@tebuto/forms/StreetFormField'
import ZipFormField from '@tebuto/forms/ZipFormField'
import { useComponentTranslation } from '@tebuto/functions/translation.components'
import { useContext } from 'react'
import { WidgetAuthContext } from '../booking-widget/widget-auth'

export default function BookingAddressFields() {
    const { t } = useComponentTranslation()
    // Set inside the embedded widget only — the client portal falls back to its env default
    const { apiUrl } = useContext(WidgetAuthContext)
    return (
        <div className="grid gap-6">
            <h3 className="text-base xs:text-lg font-medium widget-text-primary">{t('address')}</h3>
            <StreetFormField
                label={'Straße und Hausnummer'}
                name={'address.streetAndNumber'}
                zipFieldName={'address.city.zip'}
                cityFieldName={'address.city.name'}
                lookupBaseUrl={apiUrl}
                autoComplete="street-address"
                mandatory
                fieldClassName="widget-bg-field widget-border widget-text-primary"
                labelClassName="widget-text-secondary"
            />
            <div className="flex gap-6">
                <ZipFormField
                    fieldClassName="widget-bg-field widget-border widget-text-primary"
                    label={'Postleitzahl'}
                    name={'address.city.zip'}
                    cityFieldName={'address.city.name'}
                    lookupBaseUrl={apiUrl}
                    autoComplete="postal-code"
                    className="w-20 grow-0"
                    mandatory
                    labelClassName="widget-text-secondary"
                />
                <CityFormField
                    label={'Stadt'}
                    name={'address.city.name'}
                    zipFieldName={'address.city.zip'}
                    lookupBaseUrl={apiUrl}
                    autoComplete="address-level2"
                    fieldClassName="widget-bg-field widget-border widget-text-primary"
                    className="grow"
                    labelClassName="widget-text-secondary"
                    mandatory
                />
            </div>
        </div>
    )
}
